

export const PROPERTY_TAB_GENERAL = 'GeneralConstruction';
export const PROPERTY_TAB_GENERAL_SITUATIONANDTYPE = 'generalSituationAndTypeOfProperty';
export const PROPERTY_TAB_ROOM = 'Room';
export const PROPERTY_TAB_ADMINISTARTION = 'Administration';
export const PROPERTY_TAB_PUBTEXT = 'DescriptionOrPubText';
export const PROPERTY_TAB_DESCRIPTIONS = 'DescriptionOrPubText';
export const PROPERTY_TAB_DOCUMENTS = 'Document';
export const PROPERTY_TAB_PICTURES = 'Picture';
export const PROPERTY_TAB_PUBLISH_PLAN = 'PublPlanning';
export const PROPERTY_TAB_EVOLUTION_PICTURES = 'EvolutionPicture';
export const PROPERTY_TAB_ENVIRONMENT_PICTURES = 'EnvironmentPicture';
export const PROPERTY_TAB_VIRTUAL_TOUR = 'VirtualTour';
export const PROPERTY_TAB_VIRTUAL_TOUR_VIDEO = 'Video';
export const PROPERTY_TAB_FEATURES = 'Feature';
export const PROPERTY_TAB_RELATION = 'Relation';
export const PROPERTY_TAB_FINANCE = 'Finance';
export const PROPERTY_TAB_ENVIRONMENT = 'Environment';
export const PROPERTY_TAB_ENVIRONMENTS = 'Environments';
export const PICTURES_OF_ENVIRONMENT = 'PicturesOfEnvironment';
export const PROPERTY_TAB_CONSTRUCTION = 'GeneralConstruction';
export const PROPERTY_TAB_COSTS = 'Cost';
export const OBJECT_TYPE = {
    "PROPERTY": "0",
    "PROJECT": "1",
    "UNITS": "2",
    "ANNEX": "3",
};

export enum TYPE_SIGN_VALUE {
    EMAIL = 'Email',
    LIVE = 'Live'
}
export const TYPE_SIGN: Array<{label: string, value: string, hint?: string}> = [
    {label: 'EMAIL', value: TYPE_SIGN_VALUE.EMAIL, hint: 'SEND_AN_EMAIL_FOR_THE_USER_TO_SIGN'},
    {label: 'LIVE', value: TYPE_SIGN_VALUE.LIVE, hint: 'THE_USER_CAN_SIGN_IN_PERSON_AT_THE_OFFICE'},
]

export const PROJECT_TAB_BUILDING = "ProjectBuildings";

export const RELATION_MAP = {
    actualtenant: "actual tenant",
    newtenant: "new tenant",
    buyer: "buyer",
    proprietors: "proprietors",
    bodycorporate: "body corporate",
    "notary/seller": "notary/seller",
    "notary/buyer": "notary/buyer",
    manager: "manager",
    family: "family",
    "co-agent": "co-agent",
    various: "various",
    leavingtenant: "leaving tenant",

};